import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import memorandumOfAssociationPdf from "../../../../assets/tenders/resource/resource_Documents/Memorandum of Association.pdf";
import governmentGuaranteeDeedPdf from "../../../../assets/tenders/resource/resource_Documents/Format of Government Guarantee Deed.pdf";
import oneTimeSettlementSchemePdf from "../../../../assets/tenders/resource/resource_Documents/One Time Settlement Scheme.pdf";
import writingOffLoansSchemePdf from "../../../../assets/tenders/resource/resource_Documents/Scheme for Writing Off of Loans.pdf";
import boardMembersTrainingPolicyPdf from "../../../../assets/tenders/resource/resource_Documents/Policy on Training for Board Members.pdf";
import generalLoanAgreementFormatPdf from "../../../../assets/tenders/resource/resource_Documents/General Loan Agreement Format.pdf";
import microFinancingGuidelinesPdf from "../../../../assets/tenders/resource/resource_Documents/Guidelines for Implementation of Micro Financing Schemes of NMDFC.pdf";
import mou20212022Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2021-2022.pdf";
import mou20202021Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2020-2021.pdf";
import mou20192020Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU  2019-2020.pdf";
import mou20182019Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU  2018-2019.pdf";
import mou20172018Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU  2017-2018.pdf";
import mou20162017Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2016-2017.pdf";
import mou20152016Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2015-2016.pdf";
import mou20142015Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2014-2015.pdf";
import mou20132014Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2013-2014.pdf";
import mou20122013Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2012-2013.pdf";
import mou20102011Pdf from "../../../../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2010-2011.pdf";

const resourceDocuments = [
  // {
  //   serial: 1,
  //   title: "Memorandum of Understanding",
  //   path: "/resources/resource-documents/memorandum-of-understanding",
  // },
  // {
  //   serial: 1,
  //   title: "Memorandum & Articles of Association",
  //   fileName: "Memorandum of Association.pdf",
  //   href: memorandumOfAssociationPdf,
  // },
  {
    serial: 1,
    title: "Format of Government Guarantee Deed",
    fileName: "Format of Government Guarantee Deed.pdf",
    href: governmentGuaranteeDeedPdf,
  },
  {
    serial: 2,
    title: "One Time Settlement Scheme",
    fileName: "One Time Settlement Scheme.pdf",
    href: oneTimeSettlementSchemePdf,
  },
  {
    serial: 3,
    title: "Scheme for Writing Off of Loans",
    fileName: "Scheme for Writing Off of Loans.pdf",
    href: writingOffLoansSchemePdf,
  },
  {
    serial: 4,
    title: "Policy on Training for Board Members",
    fileName: "Policy on Training for Board Members.pdf",
    href: boardMembersTrainingPolicyPdf,
  },
  {
    serial: 5,
    title: "General Loan Agreement Format",
    fileName: "General Loan Agreement Format.pdf",
    href: generalLoanAgreementFormatPdf,
  },
  {
    serial: 6,
    title: "Guidelines for Implementation of Micro Financing Schemes",
    fileName: "Guidelines for Implementation of Micro Financing Schemes of NMDFC.pdf",
    href: microFinancingGuidelinesPdf,
  },
];

const memorandumOfUnderstandingDocuments = [
  {
    serial: 1,
    title: "Memorandum of Understanding (MOU) for the year 2021-2022",
    fileName: "MOU 2021-2022.pdf",
    href: mou20212022Pdf,
  },
  {
    serial: 2,
    title: "Memorandum of Understanding (MOU) for the year 2020-2021",
    fileName: "MOU 2020-2021.pdf",
    href: mou20202021Pdf,
  },
  {
    serial: 3,
    title: "Memorandum of Understanding (MOU) for the year 2019-2020",
    fileName: "MOU  2019-2020.pdf",
    href: mou20192020Pdf,
  },
  {
    serial: 4,
    title: "Memorandum of Understanding (MOU) for the year 2018-2019",
    fileName: "MOU  2018-2019.pdf",
    href: mou20182019Pdf,
  },
  {
    serial: 5,
    title: "Memorandum of Understanding (MOU) for the year 2017-2018",
    fileName: "MOU  2017-2018.pdf",
    href: mou20172018Pdf,
  },
  {
    serial: 6,
    title: "Memorandum of Understanding (MOU) for the year 2016-2017",
    fileName: "MOU 2016-2017.pdf",
    href: mou20162017Pdf,
  },
  {
    serial: 7,
    title: "Memorandum of Understanding (MOU) for the year 2015-2016",
    fileName: "MOU 2015-2016.pdf",
    href: mou20152016Pdf,
  },
  {
    serial: 8,
    title: "Memorandum of Understanding (MOU) for the year 2014-2015",
    fileName: "MOU 2014-2015.pdf",
    href: mou20142015Pdf,
  },
  {
    serial: 9,
    title: "Memorandum of Understanding (MOU) for the year 2013-2014",
    fileName: "MOU 2013-2014.pdf",
    href: mou20132014Pdf,
  },
  {
    serial: 10,
    title: "Memorandum of Understanding (MOU) for the year 2012-2013",
    fileName: "MOU 2012-2013.pdf",
    href: mou20122013Pdf,
  },
  {
    serial: 11,
    title: "Memorandum of Understanding (MOU) for the year 2010-2011",
    fileName: "MOU 2010-2011.pdf",
    href: mou20102011Pdf,
  },
];

const ResourceDocumentsTable = ({
  title,
  documents,
  minWidth = "760px",
  showSerial = true,
}) => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-3 text-[18px] font-bold text-[#005856]">{title}</h2>
    <PdfDocumentTable
      documents={documents}
      minWidth={minWidth}
      showSerial={showSerial}
    />
  </section>
);

const ResourceDocuments = ({ activeDocument }) => {
  if (activeDocument === "memorandum-of-understanding") {
    return (
      <ResourceDocumentsTable
        title="Memorandum of Understanding"
        documents={memorandumOfUnderstandingDocuments}
        minWidth="780px"
      />
    );
  }

  if (activeDocument === "memorandum-of-association") {
    return (
      <ResourceDocumentsTable
        title="Memorandum & Articles of Association"
        documents={resourceDocuments.filter(
          (document) =>
            document.title === "Memorandum & Articles of Association",
        )}
        minWidth="680px"
        showSerial={false}
      />
    );
  }

  if (activeDocument === "policy-on-training-for-board-members") {
    return (
      <ResourceDocumentsTable
        title="Policy on Training for Board Members"
        documents={resourceDocuments.filter(
          (document) =>
            document.title === "Policy on Training for Board Members",
        )}
        minWidth="680px"
        showSerial={false}
      />
    );
  }

  return (
    <ResourceDocumentsTable
      title="Resource Documents"
      documents={resourceDocuments}
      minWidth="780px"
    />
  );
};

export default ResourceDocuments;
